import apiClient from './client';
import { Company } from '../types/Company';
import { API_ENDPOINTS } from './endpoints';
import { UserRole } from '../types/Auth';

export const getCompany = async (userId: string): Promise<Company> => {
    // In a real app, you'd make a GET request to your backend here.
    console.log('Fetching company for user', userId);

    // Mock response
    const company: Company = {
        id: '123',
        name: 'Smart Inc.',
    };

    return Promise.resolve(company);
};

export const getCompanyById = async (id: string): Promise<Company> => {
    const response = await apiClient.get(`${API_ENDPOINTS.COMPANIES}/${id}`);
    return response.data;
};


export const createCompany = async (formData: FormData): Promise<Company> => {
    const response = await apiClient.post(API_ENDPOINTS.COMPANIES, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data;
};

export const getCompanies = async (): Promise<Company[]> => {
    const response = await apiClient.get(API_ENDPOINTS.COMPANIES);
    const data = response.data;

    // The API might return an array directly, or an object with a `data` or `companies` property.
    if (Array.isArray(data)) {
        return data;
    }
    if (data && Array.isArray(data.data)) {
        return data.data;
    }
    if (data && Array.isArray(data.companies)) {
        return data.companies;
    }

    // If the structure is unexpected, log a warning and return an empty array to prevent crashes.
    console.warn("Unexpected data structure from getCompanies API:", data);
    return [];
};

export const updateCompany = async ({ id, data }: { id: string, data: Partial<Company> }): Promise<Company> => {
    const response = await apiClient.patch(`${API_ENDPOINTS.COMPANIES}/${id}`, data);
    return response.data;
};

export const deactivateCompany = async (id: string): Promise<void> => {
    await apiClient.delete(`${API_ENDPOINTS.COMPANIES}/${id}`);
};

export const addUserToCompany = async ({ companyId, userId, role }: { companyId: string, userId: string, role: UserRole }): Promise<void> => {
    await apiClient.post(`${API_ENDPOINTS.COMPANIES}/${companyId}/users`, { userId, roles: [role] });
};
